import React from "react";
import { FileText } from "lucide-react";
import { Rule } from "@/components/site/Primitives";

export function EmptyState({ icon: Icon = FileText, title, body }) {
  return (
    <div className="mx-auto max-w-xl border border-dashed border-gold-500/40 bg-cream-200/50 px-8 py-16 text-center" data-testid="empty-state">
      <Icon className="mx-auto h-10 w-10 text-gold-500/70" strokeWidth={1.25} />
      <Rule className="mx-auto my-5" />
      <h3 className="font-serif text-2xl font-light text-ink">{title}</h3>
      <p className="mt-3 font-sans text-sm leading-relaxed text-steel-600">{body}</p>
    </div>
  );
}
